export enum CountryActionType {
  LoadingCountry = 'country/LOADING_COUNTRY',
  UserLocation = 'country/USER_LOCATION',
}
